<template>
    <b-container fluid>
        <table-responsive responsive ref="tableResponsive" :items="beziehungen" :field-definition="fields">
            <template v-slot:agis="data" :id="'AGIS'+data.item.agis">
                {{ data.item.agis }}<br>
                {{ data.item.strasse }}
            </template> 
            <template v-slot:milchkaeufer="data" :id="'MK' + data.item.milchkaeufer">
                <template v-for="(kaeufer) in data.item.milchkaeufer">
                    <div class="mb-3"  v-bind:key="kaeufer.mbh">
                    {{ kaeufer.name }}, {{ kaeufer.mbh }}
                    <b-button size="sm" @click.stop="kuenden(data.item.bid, kaeufer.verwerterperid, kaeufer.tierartid)">{{ $t('Beenden') }}</b-button> <template v-for="sstX in kaeufer.sst">, {{ sstX.sstname }}</template>
                    </div>
                </template>
            </template> 
            <template v-slot:org="data" :id="'Org' + data.item.milchkaeufer">
                <template v-for="(orgX) in data.item.org">
                    <div  v-bind:key="orgX.name" class="mb-3">{{ orgX.name }}</div>
                </template>
            </template>
        </table-responsive>

        <beziehungen-kuenden ref="bkdialog"></beziehungen-kuenden>
    </b-container>
</template>

<script>
import TableResponsive from "../tableResponsive.vue";
import BeziehungenKuenden from "./BeziehungenKuenden.vue";
//import BeziehungenKuendenVue from './BeziehungenKuenden.vue';

export default {
    name: "datenpakete",
    data() {
        return {
            fields: [
                { key: 'betriebform', label: this.$t('Betriebsform')},
                { key: 'agis', label: this.$t('AGIS')},
                { key: 'milchkaeufer', label: this.$t('Milchkaeufer')},
                { key: 'org', label: this.$t('Organisation')}
            ]
        };
    },
    computed: {
        beziehungen() {
            return this.$store.state.beziehungenStore.beziehungen
        },
    },
    methods: {
       kuenden(btrid,perid,tierartid){
           this.$refs["bkdialog"].open(btrid,perid,tierartid)
           //this.$refs["charts"].setChartSeries(series);
       }
    },
    components: {
        "table-responsive": TableResponsive,
        "beziehungen-kuenden": BeziehungenKuenden
    },
    created() {
        this.$store.dispatch("loadBeziehungen")
    },
    mounted() {},
    updated() {},
};
</script>
